__turbopack_context__.v({
  "blocksBackgroundColor": "ShopOfferings-module-scss-module__CuYQJW__blocksBackgroundColor",
  "blocksFontColor": "ShopOfferings-module-scss-module__CuYQJW__blocksFontColor",
  "container": "ShopOfferings-module-scss-module__CuYQJW__container",
  "secondaryNavBackgroundColor": "ShopOfferings-module-scss-module__CuYQJW__secondaryNavBackgroundColor",
  "shopInfoMessage": "ShopOfferings-module-scss-module__CuYQJW__shopInfoMessage",
  "themeBackgroundColor": "ShopOfferings-module-scss-module__CuYQJW__themeBackgroundColor",
  "themeFontColor": "ShopOfferings-module-scss-module__CuYQJW__themeFontColor",
});
